module.exports = __webpack_public_path__ + "img/Cymbal_Sub.75126b4f.png";